import React from 'react'; 
import {Row, Col, Label, Button, FormGroup, Table,
         FormControl, ControlLabel, ButtonToolbar, Glyphicon} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';


@injectIntl @inject("rootStore") @observer
export default class CostStructureForm extends React.Component{

  constructor(props){
    super(props);

    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render(){
    let activityEdit = this.props.rootStore.activityStore.activityEdit;
    const {intl} = this.props;
    return(
      <div>
        <Row>
          <Col xs={8} className="cost-description-col">
            <FormGroup
              controlId="description"
              >
              <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
              <FormControl className="subject" value={activityEdit.costDescriptionEdit}
                onChange={this.handleDescriptionChange} type="text" />
            </FormGroup>
          </Col>
          <Col xs={4} className="cost-value-col" >          
            <FormGroup
              controlId="value"
              >
              <ControlLabel>{intl.formatMessage({id: "cost"})}</ControlLabel>
              <FormControl className="subject" value={activityEdit.costValueEdit}
                onChange={this.handleValueChange} type='number' step='0.01' />
            </FormGroup>
          </Col>
          <Col xs={12} className="text-right">
            <ButtonToolbar>
              <Button bsStyle="primary" onClick={this.handleSubmit}>
                 {intl.formatMessage({id: "add_cost"})}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <br /><span className="bold">{intl.formatMessage({id: "costs"})}</span><br />
              <div className="costs-table">
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({id: "description"})}</th>
                      <th>{intl.formatMessage({id: "cost"})}</th>
                    </tr>
                  </thead>
                  <tbody>
                    { activityEdit.costs.map( (el, idx) => 
                          <tr key={idx}>
                            <td>                            
                              <div className="lean-element">
                                {el.description}
                                <Glyphicon className="btn-transparent"
                                  glyph="trash" onClick={() => activityEdit.removeCost(el.id)}>
                                </Glyphicon>
                              </div>
                            </td>
                            <td>{el.value}</td>
                          </tr>
                    )}
                  </tbody>
                </Table>
              </div>
          </Col>
        </Row>
      </div>
    );
  }

  handleValueChange(e){
    this.props.rootStore.activityStore.activityEdit.handleCostValueChange(e.target.value);
  }

  handleDescriptionChange(e){
    this.props.rootStore.activityStore.activityEdit.handleCostDescriptionChange(e.target.value);
  }

  handleSubmit(){
    this.props.rootStore.activityStore.activityEdit.addCost();
  }

}